export interface GuideTopic {
  icon: string;
  titleKey: string;
  bodyKey: string;
  route: string;
}

// Shared between the first-login welcome dialog and the standing Help page so
// the two descriptions of what a page does never drift apart. Text lives in
// translations.ts under the "guide" namespace, keyed by these titleKey/bodyKey
// — templates resolve them through the translate pipe, not read directly here.
export const GUIDE_TOPICS: GuideTopic[] = [
  {
    icon: 'dashboard',
    titleKey: 'guide.overviewTitle',
    bodyKey: 'guide.overviewBody',
    route: '/overview'
  },
  {
    icon: 'groups',
    titleKey: 'guide.employeesTitle',
    bodyKey: 'guide.employeesBody',
    route: '/employees'
  },
  {
    icon: 'restaurant',
    titleKey: 'guide.cateringTitle',
    bodyKey: 'guide.cateringBody',
    route: '/catering'
  },
  {
    icon: 'receipt_long',
    titleKey: 'guide.purchasesTitle',
    bodyKey: 'guide.purchasesBody',
    route: '/purchases'
  }
];
